
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const RelatedReading: React.FC = () => {
  return (
    <section className="mt-12 border-t border-gray-200 pt-8">
      <h2 className="text-2xl font-bold text-itmgmt-dark-blue mb-6">Related Reading</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card className="hover:shadow-md transition-shadow">
          <CardHeader className="pb-2">
            <CardTitle className="text-lg">
              <Link to="/blog/cybersecurity-best-practices-small-business" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue">
                Cybersecurity Best Practices for Small Businesses
              </Link>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-600 text-sm">
              Protect your real estate business from cyber threats with these essential security measures.
            </p>
          </CardContent>
        </Card>
        
        <Card className="hover:shadow-md transition-shadow">
          <CardHeader className="pb-2">
            <CardTitle className="text-lg">
              <Link to="/blog/secure-document-management-cpa-firms" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue">
                Secure Document Management for Professional Firms
              </Link>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-600 text-sm">
              Learn document management best practices that apply to real estate transaction records.
            </p>
          </CardContent>
        </Card>
        
        <Card className="hover:shadow-md transition-shadow">
          <CardHeader className="pb-2">
            <CardTitle className="text-lg">
              <Link to="/blog/cloud-migration-guide-small-businesses" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue">
                Cloud Migration Guide for Small Businesses
              </Link>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-600 text-sm">
              Discover how moving to the cloud can enhance your real estate agency's flexibility and security.
            </p>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default RelatedReading;
